import React, { useEffect, useReducer, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import TextInput from '../../components/Common/TextInput';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import ajaxStaff from '../../util/remote/ajaxStaff';
import { useStaff } from '../../DataStore/StaffContext';
import { useTheme } from '../../DataStore/ThemeContext';

const initialState = {
    fname: '',
    lname: '',
    prefix: '',
    reg_no: '',
    dob: '',
    sex: '',
    reg_date: '',
    contact: '',
    home_contact: '',
    email: '',
    marital_status: '',
    status: 1,
    photo: null,
    staff_category: '',
    departure_date: '',
    user_id: '',
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, [action.field]: action.value };
        case 'reset':
            return initialState;
        default:
            return state;
    }
};

const NewStaffPage = () => {
    const [loading, setLoading] = useState(false);
    const [formData, dispatchForm] = useReducer(reducer, initialState);
    const {getPrefixes, prefixes} = useStaff();
    const {setNotify} = useTheme();

    useEffect(()=>{
        getPrefixes();
    }, [])


    const handleInputChange = (field, value) => {
        dispatchForm({ type: 'update', field, value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.fname || !formData.lname || !formData.sex) {
            setNotify(<Notification type="danger" message="Please fill in all required fields." />);
            return;
        }

        const data = { 
            first_name: formData.fname,
            last_name: formData.lname,
            prefix_id: formData.prefix,
            gender: formData.sex,
            work_contact: formData.contact,
            home_contact: formData.home_contact,
            email: formData.email,
            marital_status: formData.marital_status,
            date_of_birth: formData.dob,
            registration_date: formData.reg_date,
         };

        setLoading(true);
        const server_response = await ajaxStaff.registerStaff(data);
        setLoading(false);

        if (server_response.status === 'OK') {
            setNotify(<Notification type="success" message={server_response.message} />);
            dispatchForm({ type: 'reset' });
        } else {
            setNotify(<Notification type="danger" message={server_response.message} />);
        }
    };

    const maritalStatusOptions = [
        { label: 'Single', value: 1 },
        { label: 'Married', value: 2 },
        { label: 'Other', value: 3 },
    ];

    const prefixOptions = Array.isArray(prefixes) ? prefixes.map(prefix => ({ label: prefix.prefix, value: prefix.id })) : [];


    return (
        <PageContainer>
            <MainContent>
                <PageTitle title="New Staff" description="Enroll new staff to the system." iconClass="fa fa-briefcase" />

                <div className="card mb-3">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <h5 className="mb-3">Personal Information</h5>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Prefix" options={prefixOptions} onChange={item => handleInputChange('prefix', item.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="Surname" value={formData.lname} onChange={e => handleInputChange('lname', e.target.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="First Name" value={formData.fname} onChange={e => handleInputChange('fname', e.target.value)} required wrap /></div>

                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Gender" options={[{ label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }]} onChange={item => handleInputChange('sex', item.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="date" label="Date of Birth" value={formData.dob} onChange={e => handleInputChange('dob', e.target.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="date" label="Registration Date" value={formData.reg_date} onChange={e => handleInputChange('reg_date', e.target.value)} wrap /></div>
                            </div>
                            <h5 className="mb-3 mt-4">Contact & Employment</h5>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput label="Phone Contact" value={formData.contact} onChange={e => handleInputChange('contact', e.target.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="Home Contact" value={formData.home_contact} onChange={e => handleInputChange('home_contact', e.target.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="Email Address" value={formData.email} onChange={e => handleInputChange('email', e.target.value)} wrap /></div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Marital Status" options={maritalStatusOptions} onChange={item => handleInputChange('marital_status', item.value)} wrap /></div>
                            </div>
                            <div className="text-right">
                                {!loading ? (
                                    <button className="btn btn-primary btn-lg" type="submit">Register Staff</button>
                                ) : (
                                    <ActivityLoader />
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default NewStaffPage;
